export const gaugeConfig = {
  regular: {
    titleSize: 'text-sm 2xl:text-xl -mt-2 2xl:-mt-4',
    valueClasses: 'text-md lg:top-[45%] lg-xl:top-[60%] 2xl:top-[48%] 2xl:text-2xl 4xl:text-lg',
    uomClasses: 'text-[10px] 2xl:text-xs -mt-2 2xl:-mt-1',
    labelClasses: '',
    doughtnutContainerClasses: 'w-full h-[95%] lg-xl:h-full xl:w-[95%] 2xl:w-full -mt-4',
    splitsWidth: 1.5,
  },
  bigger: {
    titleSize: 'text-sm 2xl:text-xl -mt-2 2xl:-mt-4',
    valueClasses: 'top-[52%] text-xl xl-2xl:text-3xl xl-2xl:top-[55%] lg-xl:top-[60%] 2xl:top-[52%] 2xl:text-4xl 4xl:text-lg',
    uomClasses: 'text-[10px] 2xl:text-lg -mt-2 2xl:-mt-2',
    labelClasses: '',
    doughtnutContainerClasses: 'w-full h-[95%] lg-xl:h-full xl:w-[95%] 2xl:w-full -mt-4',
    splitsWidth: 1.5,
  },
  large: {
    titleSize: 'text-2xl lg-xl:text-3xl lg-xl:-mt-4 2xl:-mt-8',
    valueClasses: 'text-5xl lg-xl:text-2xl xl:top-[48%] top-[50%] 2xl:text-6xl 2xl:top-[56%] 3xl:text-4xl',
    uomClasses: 'text-sm -mt-1 2xl:mt-0',
    labelClasses: '',
    doughtnutContainerClasses: 'h-[85%] xl:h-[90%] 2xl:h-[85%] lg-xl:h-full lg-xl:-mt-8 lg:w-full outlin xl:w-[93%] 2xl:w-[100%]',
    splitsWidth: 3,
  },
  wide: {
    titleSize: 'text-xl -mt-3.5 xl:-mt-2',
    valueClasses: 'top-[45%] text-lg lg-xl:text-md xl-2xl:text-xl xl-2xl:top-[58%] 2xl:text-2xl 2xl:top-[46%] 3xl:top-[63%] 4xl:top-[66%]',
    uomClasses: 'text-[10px] 2xl:text-xs -mt-3 2xl:-mt-1',
    labelClasses: '',
    doughtnutContainerClasses: 'w-[65%] xl:w-[60%] xl-2xl:w-[70%] h-[100%] mx-auto -mt-4 2xl:-mt-6',
    splitsWidth: 2,
  },
  unity: {
    titleSize: 'text-lg -mt-2',
    valueClasses: 'top-[60%] left-[0%]',
    uomClasses: 'text-xs ',
    labelClasses: '',
    doughtnutContainerClasses: 'w-[60%] mb-6',
    splitsWidth: 1,
  },
  smallest: {
    titleSize: 'text-md -mt-2',
    valueClasses: 'top-[60%] left-[0%] text-sm',
    uomClasses: 'text-xs ',
    labelClasses: '',
    doughtnutContainerClasses: 'w-[90%] h-[10vh] mb-1',
    splitsWidth: 1,
  }
};